import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { Gynecology2Sidebar } from "../Layouts/Gynecology2Sidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
// import { GynecologySidebar } from '../Layouts/GynecologySidebar';

export class G2AntenatalHistory extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      AttendedAntenatalCare: "",
      NumPreviousVisits: "",
      FaciltyPreviousVisits: "",
      AntiTetanusVaccination: "",
      NumPreviousVaccinations: "",
      LastVaccinationDate: "",
      PreviousFacilityVisitDate: "",
      DataLoaded: false,

      myParentTrigger: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".checkHistory").click(function () {
      $(".HistoryModal").show();
    });
    $(".antenatalCareAttendedYes").on("click", function () {
      // alert('kkk')
      $(".numberOfVisit1").show();
    });
    $(".noAnswer1").on("click", function () {
      // alert('kkk')
      $(".numberOfVisit1").hide();
    });
    $(".no2").on("click", function () {
      // alert('kkk')
      $(".numberOfVisit2").hide();
    });

    $(".PerformedAntiTetanusVaccination").on("click", function () {
      $(".numberOfVisit2").show();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    console.log(this.state);
    axios
      .post(
        this.api_url+"gynecology2/antenatal/main",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/gynecology2/ob/sound";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  handleTableChange(event) {
    console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    var self = this;
    this.setState({ AnteNatalHistoryTableResult: event });
    setTimeout(function () {
      console.log(self.state);
    }, 500);
  }

  render() {
    //Editable table variables
    const data = [
      ["1st", "", ""],
      ["2nd", "", ""],
      ["3rd", "", ""],
      // ["4th", "", ""],
    ];
    const columns = ["Trimester", "Date", "Result"];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const autoscroll = { overflowY: "auto" };

    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      AttendedAntenatalCare,
      NumPreviousVisits,
      FaciltyPreviousVisits,
      AntiTetanusVaccination,
      NumPreviousVaccinations,
      LastVaccinationDate,
      AnteNatalHistoryPreviousObstetricUltrasound,
      AnteNatalHistoryNumPreviousUltrasound,
      PreviousFacilityVisitDate,
    } = this.state;
    return (
      <div>
        <Headers />
        <Gynecology2Sidebar />

        <main className="content-container ">
          <div className="container p-2">
            {/* <a className="btn btn-primary checkHistory">Check Patient History</a> */}
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Attended Antenatal care
                  </p>
                </div>
                <div className="col-md-12 p-2">
                  {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Attended Antenatal Care
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={AttendedAntenatalCare}
                      name="AttendedAntenatalCare"
                      required
                    >
                      <optgroup label="Attended Antenatal Care">
                        <option selected disabled></option>
                        <option
                          value="yes"
                          className="antenatalCareAttendedYes"
                          selected
                        >
                          Yes
                        </option>
                        <option value="no" className="noAnswer1">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1 numberOfVisit1" style={displayHidden}>
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Visit
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumPreviousVisits}
                      name="NumPreviousVisits"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                {/* Performed Anti- Tetanus Vaccination  */}
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Performed Anti-Tetanus Vaccination{" "}
                    </h6>
                    <select
                      onChange={this.handleChange}
                      value={AntiTetanusVaccination}
                      name="AntiTetanusVaccination"
                      className="form-control"
                      required
                    >
                      <optgroup label="Performed Anti-Tetanus Vaccination ">
                        <option selected disabled></option>
                        <option
                          value="yes"
                          className="PerformedAntiTetanusVaccination"
                          selected
                        >
                          Yes
                        </option>
                        <option value="no" className="no2">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div
                  className="col-md-6 p-2 numberOfVisit2"
                  style={displayHidden}
                >
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Facility Previous Visits
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={FaciltyPreviousVisits}
                      name="FaciltyPreviousVisits"
                      className="form-control"
                      type="text"
                    />
                  </div>
                </div>
                <div
                  className="col-md-6  numberOfVisit2 p-2"
                  style={displayHidden}
                >
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Previous Facility Visit Date
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={PreviousFacilityVisitDate}
                      name="PreviousFacilityVisitDate"
                      className="form-control"
                      type="date"
                    />
                  </div>
                </div>

                <div
                  className="col-md-6 p-2 numberOfVisit2"
                  style={displayHidden}
                >
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Previous Vaccination
                    </h6>
                    <input
                      className="form-control numberofVisit2"
                      onChange={this.handleChange}
                      value={NumPreviousVaccinations}
                      name="NumPreviousVaccinations"
                      type="text"
                    />
                  </div>
                </div>
                <div
                  className="col-md-6 p-2 numberOfVisit2"
                  style={displayHidden}
                >
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={LastVaccinationDate}
                      name="LastVaccinationDate"
                      className="form-control"
                      type="date"
                    />
                  </div>
                </div>
              </div><div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
            <div
              className="modal HistoryModal"
              style={autoscroll}
              tabIndex="-1"
              role="dialog"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title PatientName"></h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <MDBCard>
                      <MDBCardHeader
                        tag="h3"
                        className="text-center font-weight-bold text-capitalise py-4"
                      >
                        Patient History
                      </MDBCardHeader>
                      <MDBCardBody>
                        <MDBTableEditable
                          onChange={(value) => this.handleTableChange(value)}
                          getValue={(value) => this.getTableValues(value)}
                          myParentTrigger={this.state.myParentTrigger}
                          id="editablecard"
                          data={data}
                          columns={columns}
                          striped
                          bordered
                        />
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary start_visit"
                      id=""
                    >
                      Start Visit
                    </button>
                    {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default G2AntenatalHistory;
